import React, { useEffect, useState } from "react";
import { Header, LoadingSpinner, FormShared } from "../../shared/compoments";
import instance from "../../api/api";
import { useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

let DATA_INFO_FORM_INPUT = [];
function EditerPersonnel() {
  const { id } = useParams();
  const location = useLocation();
  const messageByRoute = location.state?.message;
  console.log("messageByRoute", messageByRoute);
  const MySwal = withReactContent(Swal);

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [isLoadingBtnForPaswword, setIsLoadingBtnForPaswword] = useState(false);
  const [detailPersonnel, setDetailPersonnel] = useState(null);
  //  const [allPermission, setAllPermission] = useState([]);
  const [selectedPermission, setSelectedPermission] = useState(null);
  const [data, setData] = useState({
    adresse: "",
    email: "",
    nom: "",
    phone: "",
    prenom: "",
    profession: "",
  });
  const [dataPassword, setDataPassword] = useState({
    oldPassword: "",
    password: "",
  });
  const DATA_INPUT_PASSWORD = [
    {
      labelInput: "Ancien mot de passe",
      typeInput: "password",
      nameInput: "mot de passe",
      isForModifyOrNotModify: true,
      isApplyValueByDefault: true,
      handleValue: (e) => {
        setDataPassword({ ...dataPassword, oldPassword: e.target.value });
      },
      dataValue: dataPassword.oldPassword,
    },
    {
      labelInput: "Nouveau mot de passe",
      typeInput: "password",
      nameInput: "mot de passe",
      isForModifyOrNotModify: true,
      isApplyValueByDefault: true,
      handleValue: (e) => {
        setDataPassword({ ...dataPassword, password: e.target.value });
      },
      dataValue: dataPassword.password,
    },
  ];
  const getInfoFormInput = (adresse, email, nom, prenom, phone, profession) => {
    DATA_INFO_FORM_INPUT = [
      {
        labelInput: "Nom",
        typeInput: "text",
        nameInput: "Nom",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setData({ ...data, nom: e.target.value });
        },
        dataValue: nom,
        isDisabledInput: true,
      },
      {
        labelInput: "Prénoms",
        typeInput: "text",
        nameInput: "prenoms",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setData({ ...data, prenom: e.target.value });
        },
        dataValue: prenom,
        isDisabledInput: true,
      },
      {
        labelInput: "Adresse",
        typeInput: "text",
        nameInput: "lieu",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setData({ ...data, adresse: e.target.value });
        },
        dataValue: adresse,
      },
      {
        labelInput: "Email",
        typeInput: "text",
        nameInput: "email",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setData({ ...data, email: e.target.value });
        },
        dataValue: email,
      },
      {
        labelInput: "Contact",
        typeInput: "number",
        nameInput: "Contact",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setData({ ...data, phone: e.target.value });
        },
        dataValue: phone,
      },
      {
        labelInput: "Profession",
        typeInput: "text",
        nameInput: "profession",
        isForModifyOrNotModify: true,
        isApplyValueByDefault: true,
        handleValue: (e) => {
          setData({ ...data, profession: e.target.value });
        },
        dataValue: profession,
      },
    ];
  };
  const updateInfoPersonnel = async (e) => {
    e.preventDefault();
    setIsLoadingBtn(true);
    try {
      const response = await instance.put(`users/${id}`, data);
      console.log("updateInfoPersonnel", response);
      if (response.data.status) {
        MySwal.fire({
          title: "Modification réussie",
          icon: "success",
          showConfirmButton: true,
        });
      }
      setIsLoadingBtn(false);
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoadingBtn(false);
    }
  };
  const handleSubmitPassword = async (e) => {
    e.preventDefault();
    setIsLoadingBtnForPaswword(true);
    try {
      const response = await instance.post(`modifyPassword/`, {
        email: data.email,
        oldPassword: dataPassword.oldPassword,
        password: dataPassword.password,
      });
      console.log("handleSubmitPassword", response);
      if (response.data.status) {
        MySwal.fire({
          title: "Modification réussie",
          icon: "success",
          showConfirmButton: true,
        });
      }
      setIsLoadingBtnForPaswword(false);
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoadingBtnForPaswword(false);
    }
  };
  useEffect(() => {
    const getPersonnelDetail = async () => {
      try {
        const response = await instance.get(`users/${id}`);
        //  const responseService = await instance.get("permissions");
        console.log(response.data.data);
        const { adresse, email, nom, phone, piece, profession, prenom } =
          response.data.data;
        setDetailPersonnel(response.data.data);
        // setAllPermission(responseService.data.data);
        getInfoFormInput(adresse, email, nom, prenom, phone, piece, profession);
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };
    getPersonnelDetail();
  }, [id]);
  console.log("DATA_INFO_FORM_INPUT", DATA_INFO_FORM_INPUT);
  if (isLoading) return <LoadingSpinner />;
  return (
    detailPersonnel.nom && (
      <>
        <Header libelle={`Modifier les informations personnelles`} isReturn />
        <FormShared
          dataWithMuliselectPersmission
          // allPermission={allPermission}
          // setSelectedPermission={setSelectedPermission}
          // selectedPermission={selectedPermission}
          handleSubmit={updateInfoPersonnel}
          btnTitle={"Modifier"}
          isLoading={isLoadingBtn}
          dataInfoFormInput={DATA_INFO_FORM_INPUT}
          dataInfoFormSelect={[]}
          isPasswordModify={messageByRoute !== undefined ? true : false}
          handleSubmitPassword={handleSubmitPassword}
          dataInfoFormInputPasswordModify={DATA_INPUT_PASSWORD}
          btnTitleModifyPassword={"Modifier"}
          isLoadingBtnForPaswword={isLoadingBtnForPaswword}
        />
      </>
    )
  );
}

export default EditerPersonnel;
